"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _ChecklistItem = _interopRequireDefault(require("./ChecklistItem"));
var _reactstrap = require("reactstrap");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const checkdownButton = (checkedValues, values, propIdName, displayName) => {
  if (checkedValues && checkedValues.length > 1) {
    return /*#__PURE__*/_react.default.createElement("span", null, "Multiple (", checkedValues.length, " values)");
  } else if (checkedValues && checkedValues.length === 1) {
    return /*#__PURE__*/_react.default.createElement("span", null, checkedValues.map((checkedValue, index) => {
      const val = values.find(v => v.Id === checkedValue[propIdName]);
      return /*#__PURE__*/_react.default.createElement("span", {
        key: index
      }, val ? displayName(val, checkedValue, true) : 'Assign a value');
    }));
  } else {
    return /*#__PURE__*/_react.default.createElement("span", null, "Assign a value");
  }
};
const Checkdown = props => {
  const {
    values,
    displayName,
    propIdName,
    checkedValues,
    onAdd,
    onDrop,
    fetching,
    fetched
  } = props;
  if (fetched === false) return /*#__PURE__*/_react.default.createElement("div", null, "Not fetched");
  if (fetching === true) return /*#__PURE__*/_react.default.createElement("div", null, "Fetching data");
  if (!values) return /*#__PURE__*/_react.default.createElement("div", null, "Error");
  return /*#__PURE__*/_react.default.createElement(_reactstrap.UncontrolledButtonDropdown, {
    className: 'd-inline-block'
  }, /*#__PURE__*/_react.default.createElement(_reactstrap.DropdownToggle, {
    caret: true
  }, checkdownButton(checkedValues, values, propIdName, displayName)), /*#__PURE__*/_react.default.createElement(_reactstrap.DropdownMenu, null, values.map((value, index) => {
    const checked = checkedValues ? checkedValues.find(c => c[propIdName] === value.Id) : false;
    return /*#__PURE__*/_react.default.createElement(_reactstrap.DropdownItem, {
      toggle: false,
      key: index,
      tag: 'div'
    }, /*#__PURE__*/_react.default.createElement(_ChecklistItem.default, {
      className: 'dropdown-item',
      isChecked: !!checked,
      onCheck: () => onAdd(value),
      onUncheck: () => onDrop(checked),
      displayName: displayName(value, checked)
    }));
  })));
};
var _default = exports.default = Checkdown;
module.exports = exports.default;